import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight, ExternalLink } from "lucide-react";
import { PortfolioDataWeb, PortfolioDataMobile } from "../../Utils/PortfolioData";
import "./Portfolios.scss";

const AutoImageSlider = ({ images }) => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (!images || images.length <= 1) return;
    const itv = setInterval(() => setIndex((p) => (p === images.length - 1 ? 0 : p + 1)), 3500);
    return () => clearInterval(itv);
  }, [images]);

  return (
    <div className="slider-box">
      <AnimatePresence mode="wait">
        <motion.img
          key={index}
          src={images[index]}
          initial={{ scale: 1.2, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ duration: 1.2, ease: "circOut" }}
        />
      </AnimatePresence>
    </div>
  );
};

const Portfolios = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(location.state?.tab || "web");
  const activeData = activeTab === "web" ? PortfolioDataWeb : PortfolioDataMobile;

  return (
    <div className="portfolio-showcase-page">
      <div className="container">
        {/* Header with Navy/Gold Highlight */}
        <header className="showcase-header">
          <motion.h1 initial={{ x: -50, opacity: 0 }} animate={{ x: 0, opacity: 1 }}>
            Our Creative <span>Portfolios</span>
          </motion.h1>
          <div className="tab-control">
            <button className={activeTab === "web" ? "active" : ""} onClick={() => setActiveTab("web")}>Web Solutions</button>
            <button className={activeTab === "mobile" ? "active" : ""} onClick={() => setActiveTab("mobile")}>Mobile Apps</button>
          </div>
        </header>

        {/* The New Grid Style */}
        <div className="showcase-list">
          {activeData.map((project, idx) => (
            <motion.div 
              className="showcase-item" 
              key={project.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              onClick={() => navigate(`/portfolio/${project.id}`, { state: { tab: activeTab } })}
            >
              <div className="visual-side">
                <AutoImageSlider images={project.images} />
              </div>

              <div className="info-side">
                <span className="type-tag">{activeTab.toUpperCase()} PROJECT</span>
                <h2 className="project-name">{project.title}</h2>
                <p className="project-brief">{project.description}</p>
                <div className="btn-wrap">
                  <span className="case-link">View Case Study <ArrowRight size={20} /></span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolios;